"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styles = require("@material-ui/styles");

var _clsx = _interopRequireDefault(require("clsx"));

var _Box = _interopRequireDefault(require("@material-ui/core/Box"));

var _Info = _interopRequireDefault(require("@material-ui/icons/Info"));

var _CheckCircle = _interopRequireDefault(require("@material-ui/icons/CheckCircle"));

var _Error = _interopRequireDefault(require("@material-ui/icons/Error"));

const useStyles = (0, _styles.makeStyles)(theme => ({
  root: {
    boxShadow: '0px 1px 5px rgba(0, 0, 0, 0.12), 0px 2px 2px rgba(0, 0, 0, 0.14), 0px 1px 1px rgba(0, 0, 0, 0.2)',
    borderRadius: '2px'
  },
  iconColor: ({
    variant,
    iconColor
  }) => {
    if (!variant && !iconColor) return null;
    return {
      color: variant ? theme.palette[variant].main : iconColor
    };
  }
}));
/**
 * MessageBox is a container to show an icon follow with a relevant message.
 */

const MessageBox = ({
  className: classNameProp,
  children,
  variant,
  icon,
  iconColor,
  ...other
}) => {
  const classes = useStyles({
    variant,
    iconColor
  });
  const className = (0, _clsx.default)(classes.root, classNameProp);

  const getIcon = () => {
    if (!variant) return null;
    const iconsMapping = new Map([['warning', /*#__PURE__*/_react.default.createElement(_Info.default, {
      key: "warningIcon"
    })], ['info', /*#__PURE__*/_react.default.createElement(_Info.default, {
      key: "infoIcon"
    })], ['success', /*#__PURE__*/_react.default.createElement(_CheckCircle.default, {
      key: "successIcon"
    })], ['error', /*#__PURE__*/_react.default.createElement(_Error.default, {
      key: "errorIcon"
    })]]);
    return iconsMapping.get(variant);
  };

  const iconProp = icon !== null ? icon : getIcon();
  return /*#__PURE__*/_react.default.createElement(_Box.default, (0, _extends2.default)({
    display: "flex",
    flexDirection: "row",
    p: 2,
    my: 2,
    bgcolor: "background.paper",
    className: className
  }, other), /*#__PURE__*/_react.default.createElement(_Box.default, {
    pr: 2,
    className: classes.iconColor
  }, iconProp), children);
};

process.env.NODE_ENV !== "production" ? MessageBox.propTypes = {
  /**
   * Additional classes which need to be applied to root element
   */
  className: _propTypes.default.string,

  /**
   * Child components to be rendered within the content.
   */
  children: _propTypes.default.node,

  /**
   * Variant to use for the MessageBox.
   */
  variant: _propTypes.default.oneOf(['warning', 'info', 'success', 'error']),

  /**
   * To display a custom icon
   */
  icon: _propTypes.default.node,

  /**
   * Color for custom icon
   */
  iconColor: _propTypes.default.string
} : void 0;
MessageBox.defaultProps = {
  className: null,
  children: null,
  variant: null,
  icon: null,
  iconColor: null
};
var _default = MessageBox;
exports.default = _default;